import { render } from "./MicrositeHeader.vue?vue&type=template&id=30b617e4"
import script from "./MicrositeHeader.vue?vue&type=script&lang=js"
export * from "./MicrositeHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__